import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApiKeys } from '../../hooks';

export default function ApiKeyList() {
  const { apiKeys, getApiKeys } = useApiKeys();

  useEffect(() => {
    getApiKeys();
  }, [getApiKeys]);

  return <div className="api-key-list">
    <div className="api-key-list-header container border-bottom d-flex justify-content-between">
      <h6>API Keys</h6>
      <div className="add-button-container">
        <Link className="btn btn-primary rounded-circle" to="/status/new">
          <img src="/images/plus.svg" alt="add" />
        </Link>
      </div>
    </div>

    {
      apiKeys.length === 0 && <div className="api-key align-items-center p-3 mt-1">
        Press "+" button to create your first API key
      </div>
    }

    {
      apiKeys.length > 0 && apiKeys.map(({ id, name, description, active }) =>
        <Link key={id} to={`/status/${id}`} className="api-key key-feature align-items-center p-3 rounded shadow mt-4 ml-4 mr-4">
          <div className="media-body content ml-3">
            <h4 className="title mb-0">{name}</h4>
            <p className="text-muted mb-0">{description}</p>
            <br />
            <p className="text-muted mb-0">
              Status <span className={active ? "text-primary" : "text-danger"}>
                <strong className="text-uppercase">{active ? 'active' : 'not active'}</strong>
              </span>
            </p>
          </div>
        </Link>
      )
    }

    <br />

    {/* <Alert variant="danger">
      <strong>ATT!</strong> API Key is Inactive Due to Not Enough UTU Coin Balance
    </Alert> */}

  </div>
}